<template lang="html">
  <section class="app-update-mail">
    <h1>No available !</h1>
    <p>Reason: Can not update a mail which has already be sent !</p>
  </section>
</template>

<script lang="js">
export default {
  name: 'UpdateMail',
  props: [],
  mounted () {},
  created () {},
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
  .app-update-mail {}
</style>



// WEBPACK FOOTER //
// src/components/mails/UpdateMail.vue